var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPension(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.999,
    height: 170,
    viewBox: "0 0 211.999 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hero_pensionclip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 130,
    transform: "translate(0.286 -0.468)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.661,84.5l-.889-.552-.255-.165a8.485,8.485,0,0,0,7.044-7.962,8.391,8.391,0,0,0-.734-3.864,8.5,8.5,0,0,0-5.441-4.7l.025,3.5-1.921-3.8h-.023a8.485,8.485,0,0,0-8.877,8.079v.481a10.147,10.147,0,0,1-1.674-2.474c-.812-1.815-.837-3.868-.764-6.363.128-4.947.341-9.932.628-14.9a8.48,8.48,0,0,0,7.534-8.025c.013-.259,0-.516,0-.769v-.19c-.015-.247-.04-.491-.075-.732a.767.767,0,0,0-.023-.117q-.05-.305-.126-.6c-.017-.075-.035-.149-.056-.224a6.344,6.344,0,0,0-.209-.64c-.025-.069-.054-.138-.082-.209q-.09-.232-.195-.458c-.038-.08-.073-.159-.111-.236,0-.019-.019-.04-.029-.061a8.488,8.488,0,0,0-9.97-4.3l.059,4.548L13.593,36A8.439,8.439,0,0,0,9.546,45.14c.013.061.031.119.046.178.025.113.054.224.086.335.04.142.084.28.132.418.036.1.069.209.109.312.059.151.123.3.188.443.04.086.073.173.115.257.107.209.224.433.349.642.044.073.094.142.14.209.092.14.182.28.283.418.061.084.126.163.19.245.092.117.186.234.287.345s.142.159.209.236.209.209.32.32c.073.069.146.14.222.209.126.111.257.209.389.32.067.052.132.107.209.157.209.149.408.289.628.418.04.025.082.046.123.069.178.1.362.209.548.3.08.04.163.073.245.111.155.069.31.136.467.2.092.035.186.067.28.1.155.054.314.1.473.146.1.027.19.052.287.075.174.042.349.075.529.107h.034q-.176,3.136-.312,6.292a8.488,8.488,0,0,0-11.782-3.68l1.5,4.107L2.755,55.459A8.451,8.451,0,0,0,.012,61.313a8.311,8.311,0,0,0,.209,2.338A8.488,8.488,0,0,0,15.83,65.962c0,.209-.015.418-.021.638-.057,2.2-.128,4.943.971,7.389A14.874,14.874,0,0,0,19.907,78.2q1.157,1.179,2.388,2.281a8.514,8.514,0,0,0,3.047,2.563q2.017,1.552,4.185,2.907l.9.558c.808.5,1.636,1.014,2.449,1.549-.142-.015-.285-.031-.429-.038a8.494,8.494,0,0,0-8.36,5.522l5.3,4.312-5.834-1.351a8.5,8.5,0,0,0,12.171,7.64l-.393.489c-.262.324-.521.646-.774.966-3.453,4.368-4.411,8.514-2.7,11.676l2.065-1.12c-1.664-3.079.837-7.018,2.478-9.092.249-.316.5-.627.76-.949,2.2-2.737,4.715-5.84,4.65-9.648C41.717,90.731,36.142,87.279,31.661,84.5Z",
    transform: "translate(0 5.977)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.125,53.645l.456-.945c.042-.09.082-.182.126-.274a8.482,8.482,0,0,1-9.58-13.489l1.839,2.973-.419-4.238.019-.015a8.493,8.493,0,0,1,11.828,2.064c.094.132.176.27.26.406a10.118,10.118,0,0,0,.088-2.988c-.287-1.968-1.375-3.709-2.769-5.781-2.762-4.107-5.617-8.2-8.519-12.243a8.49,8.49,0,0,1-10.673-2.737c-.151-.209-.285-.431-.419-.65-.031-.054-.063-.111-.092-.167-.119-.209-.23-.435-.328-.657l-.044-.111a5.463,5.463,0,0,1-.209-.577c-.025-.073-.05-.144-.071-.209-.067-.209-.126-.431-.174-.648-.017-.073-.029-.146-.044-.209-.031-.163-.059-.328-.08-.491-.013-.088-.025-.173-.034-.259v-.067a8.473,8.473,0,0,1,6.094-8.987l2.392,3.87-.419-4.182a8.434,8.434,0,0,1,8.321,5.545c.021.059.036.117.056.176.038.109.073.209.107.328s.077.282.113.418c.025.107.052.209.075.322.031.157.054.316.077.475.015.092.031.184.042.276.027.243.044.487.048.73v.257c0,.167,0,.335-.015.5a2.5,2.5,0,0,1-.031.309c-.015.148-.031.3-.054.445-.017.107-.036.209-.057.314-.029.148-.063.3-.1.443-.025.1-.05.2-.077.295-.046.159-.1.318-.157.477-.027.08-.052.161-.084.24-.09.232-.188.462-.3.686-.021.042-.046.084-.069.125-.094.184-.195.366-.3.544-.046.075-.1.151-.147.226-.094.14-.188.278-.289.418-.061.08-.121.157-.184.234-.1.127-.209.253-.322.376a2.713,2.713,0,0,1-.2.209c-.126.128-.257.251-.391.372l-.025.025q1.835,2.559,3.641,5.142A8.479,8.479,0,0,1,67,13.532l.938,4.272,1.017-4.153a8.452,8.452,0,0,1,5.458,3.473,8.3,8.3,0,0,1,1.073,2.091A8.485,8.485,0,0,1,63.559,29.528c.119.178.241.353.36.529,1.23,1.83,2.76,4.1,3.139,6.758a14.874,14.874,0,0,1-.377,5.227q-.345,1.614-.791,3.205a8.5,8.5,0,0,1-1.22,3.793c-.582,1.593-1.235,3.162-1.967,4.692l-.458.951c-.419.855-.837,1.733-1.237,2.62.113-.088.224-.178.343-.261a8.5,8.5,0,0,1,10.02.182l-2.164,6.482,4.2-4.266a8.486,8.486,0,0,1-6.173,12.964l.594.209,1.172.4c5.257,1.838,8.293,4.824,8.546,8.408l-2.356.167c-.247-3.49-4.472-5.474-6.971-6.346-.379-.134-.764-.263-1.151-.4-3.329-1.129-7.115-2.409-9.095-5.656C54.984,64.288,57.838,58.387,60.125,53.645Z",
    transform: "translate(7.07 0.518)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.683,38.524l1.047-.077.3-.029a8.482,8.482,0,0,1,6.906-15.034l-1.661,3.076,3.467-2.478a.084.084,0,0,1,.021.01,8.477,8.477,0,0,1,4.109,11.272c-.067.146-.146.284-.221.418a10.181,10.181,0,0,0,2.637-1.416c1.573-1.219,2.534-3.034,3.643-5.271,2.185-4.441,4.311-8.956,6.37-13.485a8.474,8.474,0,0,1-2.948-10.605c.109-.236.232-.46.36-.682l.1-.163c.13-.209.264-.418.409-.611.022-.033.049-.063.073-.094.125-.165.258-.324.391-.477l.155-.171c.153-.163.31-.322.476-.473.054-.05.112-.1.168-.146.125-.109.255-.209.387-.316.069-.052.136-.107.21-.157l.054-.042a8.488,8.488,0,0,1,10.826.813l-2.165,4,3.43-2.442a8.422,8.422,0,0,1-.658,9.972c-.04.048-.084.09-.124.136-.075.088-.152.174-.232.255s-.21.209-.309.312-.159.153-.244.226c-.121.1-.246.209-.373.3-.073.058-.144.119-.219.176-.2.144-.4.278-.609.406-.074.044-.149.082-.224.123-.144.084-.292.165-.442.238-.095.046-.189.086-.282.128-.138.063-.274.121-.419.173-.1.04-.2.075-.3.109-.142.05-.287.094-.431.136l-.3.079c-.163.04-.326.073-.492.1-.083.017-.165.035-.248.048-.247.038-.5.067-.747.082h-.142c-.21,0-.419.013-.628,0-.088,0-.178-.01-.268-.017a4.556,4.556,0,0,1-.5-.042l-.293-.042c-.163-.025-.326-.056-.487-.092-.1-.019-.192-.04-.288-.065-.175-.044-.346-.1-.518-.151l-.035-.01q-1.3,2.867-2.645,5.717a8.489,8.489,0,0,1,12.137,2.2L168.663,27.4l4.135-1.183a8.444,8.444,0,0,1-.292,6.459,8.266,8.266,0,0,1-1.276,1.97,8.486,8.486,0,0,1-14.9-5.192q-.137.289-.278.577c-.973,1.976-2.184,4.437-4.292,6.1a14.925,14.925,0,0,1-4.726,2.281q-1.573.508-3.175.914a8.525,8.525,0,0,1-3.9.836c-1.674.293-3.36.51-5.052.638l-1.046.077c-.948.069-1.921.14-2.888.236.131.054.266.107.395.167a8.486,8.486,0,0,1,4.832,8.778l-6.7,1.361L135.3,52.92a8.495,8.495,0,0,1-14.328,1.123c.039.209.078.418.121.617.08.418.162.813.237,1.215,1.027,5.47-.048,9.587-3.03,11.6l-1.32-1.957c2.9-1.955,2.512-6.605,2.028-9.2-.073-.4-.152-.795-.232-1.194-.691-3.454-1.458-7.369.355-10.714C121.887,39.375,128.43,38.9,133.683,38.524Z",
    transform: "translate(20.053 0)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.464,57.024a48.552,48.552,0,0,1,97.1.79v88.068a8.577,8.577,0,0,1-8.58,8.572H68.464c-26.813,0-48.55-22.138-48.55-48.929A48.523,48.523,0,0,1,68.464,57.024Z",
    transform: "translate(3.414 1.531)",
    fill: "#d7e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.464,56.667A48.457,48.457,0,0,1,153.5,25.254a48.458,48.458,0,0,0-77.923,38.1,48.5,48.5,0,0,0-36.666,80.307,48.5,48.5,0,0,1,29.551-87Z",
    transform: "translate(3.414 1.47)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.714 40.468)",
    clipPath: "url(#hero_pensionclip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.971,38.893s.446.515-.319,1.512-.148,3.161,1.306,3.216,2.158.668,1.808,1.476-.772,2.726.811,2.435,2.083.343,1.8.831.705-.97.705-.97.882,1.323,1.964.4,1.513-9.324-.694-9.466A55.836,55.836,0,0,0,127.971,38.893Z",
    transform: "translate(0.113 -33.901)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.426,72.971l.5,3.545h2.263l-.754-4.052Z",
    transform: "translate(1.845 -28.045)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.931,74.086s3.018,2.786,2.263,3.039-3.52,3.292-4.023,3.545c-.45.227-5.28,1.773-4.525,0a6.633,6.633,0,0,1,2.514-2.786l.5-3.039Z",
    transform: "translate(1.355 -27.767)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.931,74.086s3.018,2.786,2.263,3.039-3.52,3.292-4.023,3.545c-.45.227-5.28,1.773-4.525,0a6.633,6.633,0,0,1,2.514-2.786l.5-3.039Z",
    transform: "translate(1.355 -27.767)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,70.7l.5,3.546h2.263l-.754-4.052Z",
    transform: "translate(2.286 -28.434)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.93,65.192l3.3-10.975s-5.531-5.065-1.761-6.584,4.777,6.078,4.777,6.078l-1.257,13.169h-5.028Z",
    transform: "translate(0.903 -32.337)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.32,55.71s-6.5,8.4-5.512,9.642,2.746,8.845,2.746,8.845-.251,3.039.754,3.039,3.52-.507,3.52-1.266-2.263-10.383-2.263-10.383l6.538-8.61Z",
    transform: "translate(1.207 -30.917)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.429,56.661l6.537-3.545s4.526,2.279,3.269,4.305-7.04,7.344-7.04,7.344,1.76,8.61,1.509,8.864-3.018,1.266-3.772,1.013-4.777-10.13-3.771-10.636,4.275-5.825,4.275-5.825Z",
    transform: "translate(1.6 -31.362)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.426,135.594s4.525,2.786,5.028,2.786,7.291,1.774,4.275,3.04-14.583-.507-14.331-1.266,0-5.318.5-5.318S124.426,135.594,124.426,135.594Z",
    transform: "translate(-1.246 -17.353)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.719,138.621s4.525,2.786,5.028,2.786,7.291,1.772,4.275,3.039-14.583-.506-14.331-1.266,0-5.317.5-5.317S128.719,138.621,128.719,138.621Z",
    transform: "translate(-0.51 -16.834)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.666,93.123a36.347,36.347,0,0,0,2.011,6.584c1.257,2.786-.251,15.955-1.005,17.98s-8.045,26.085-5.783,26.338a56.971,56.971,0,0,0,6.788,0l7.292-23.045-1.258-30.9Z",
    transform: "translate(-1.236 -25.025)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.666,93.123a36.347,36.347,0,0,0,2.011,6.584c1.257,2.786-.251,15.955-1.005,17.98s-8.045,26.085-5.783,26.338a56.971,56.971,0,0,0,6.788,0l7.292-23.045-1.258-30.9Z",
    transform: "translate(-1.236 -25.025)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.717,93.495s1.005,6.838,3.268,8.358,1.509,3.039,1.509,3.039l-1.006,13.422s-9.8,24.312-6.788,27.35,5.783,1.772,7.04,1.519,3.52-5.571,2.263-7.091,2.514-10.637,3.519-12.156,0-3.546,1.257-4.052,4.024-3.8,4.024-6.079,3.519-26.591,1.257-28.11-16.768,3.136-16.768,3.136Z",
    transform: "translate(-0.778 -25.143)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.921,64.259a5.572,5.572,0,1,0-5.53-5.572A5.552,5.552,0,0,0,121.921,64.259Z",
    transform: "translate(-1.761 -31.362)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.508,45.8a4.559,4.559,0,1,0-4.526-4.558A4.542,4.542,0,0,0,132.508,45.8Z",
    transform: "translate(0.226 -34.179)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,57.872s3.016,5.572,4.525,5.572-6.034,5.825-6.034,5.825-2.514-7.344-3.016-7.6S125,57.872,125,57.872Z",
    transform: "translate(-1.067 -30.547)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.374,62.418s-6.538,2.279-6.286,3.039-1.759,2.532-1.759,3.292-.5,7.6,2.514,13.169,7.793,9.623,5.531,12.156-5.783,6.838-2.011,6.838,9.8-5.572,15.336-3.546,4.275-5.571,4.275-5.571.754-5.825-.754-7.6-6.788-14.435-6.788-15.955S131.4,60.9,130.145,60.9,126.374,62.418,126.374,62.418Z",
    transform: "translate(-1.434 -30.028)",
    fill: "#8985a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.918,43.363a43.4,43.4,0,0,1,2.155,4.62c.108.7,3.627-4.62,3.627-4.62l-4.023-2.786Z",
    transform: "translate(1.072 -33.512)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.645,46.216l4.275-4.558,5.028,2.279s4.69,10.383,4.984,11.143-7.5,4.305-8.253,4.305-6.034-7.851-6.034-7.851S132.388,47.736,133.645,46.216Z",
    transform: "translate(1.101 -33.326)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.844,50.738V55.3h3.016l-.992-4.559Z",
    transform: "translate(0.888 -31.77)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.585,53.656a1.864,1.864,0,0,0-1.071.321,1.89,1.89,0,0,0-.7.878c-.2.535-.129,1.1.8,1.333,2.011.507,2.262,0,2.262,0s3.492-.507,2.752-1.519-2.752-1.013-2.752-1.013Z",
    transform: "translate(0.868 -31.269)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.507,72.356s3.018,2.786,2.263,3.039-3.52,3.292-4.023,3.545c-.45.227-5.28,1.773-4.525,0a6.64,6.64,0,0,1,2.514-2.786l.5-3.039Z",
    transform: "translate(1.796 -28.064)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.4,54.453c.347-.2.756-.459.765-.863a.773.773,0,0,0-.149-.41.765.765,0,0,0-.348-.261,2.21,2.21,0,0,0-.869-.118,1.128,1.128,0,0,0-.336.034c-.286.089-.451.382-.676.581a2.82,2.82,0,0,1-1.2.484,7.84,7.84,0,0,0-2.011.839.942.942,0,0,0-.317.264,1.292,1.292,0,0,0-.128.656,6.622,6.622,0,0,1-.95,2.378A2.618,2.618,0,0,0,114,60.5a8.357,8.357,0,0,1,.5.711c.317.667-.08,1.487.15,2.19a1.916,1.916,0,0,0,.481.727,3.821,3.821,0,0,0,1.584.966c.572.177,1.28.3,1.5.854a4.645,4.645,0,0,0,.212.741,1.163,1.163,0,0,0,.826.417,3.506,3.506,0,0,0,1.071.078,1.327,1.327,0,0,0,.923-.5,2.761,2.761,0,0,1,.374-.555c.364-.307.917-.064,1.385-.146a1.016,1.016,0,0,0,.793-.75,1.424,1.424,0,0,1,.162-.573c.291-.374,1.054-.11,1.246-.544.124-.282-.137-.58-.389-.755a11.039,11.039,0,0,1-1.238-.846,1.458,1.458,0,0,1-.526-1.338c.173-.734,1.125-1.139,1.156-1.893a1.354,1.354,0,0,0-.635-1.068,9.7,9.7,0,0,1-1.053-.743c-.225-.22-.4-.5-.641-.693a2.989,2.989,0,0,0-1.614-.458c-.3-.031-1.51-.172-1.462-.637C118.842,55.3,120.1,54.635,120.4,54.453Z",
    transform: "translate(-2.212 -31.417)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.048,45.333s-2.765,1.013-2.765,2.279-1.258,5.318,0,5.318a15.289,15.289,0,0,0,3.771-.972Z",
    transform: "translate(0.696 -32.696)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.2,63.826s7.291-2.533,7.543-2.533,3.771-2.026,3.519-2.786l-1.005-6.331S139.23,43.82,142,43.82s4.275,6.584,4.275,6.584,6.034,11.4,2.765,13.929-16.845,7.091-17.6,6.331S133.2,63.826,133.2,63.826Z",
    transform: "translate(0.794 -32.956)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.408,47.256l1.7,1.647-2.2,2.151s-3.018-1.266-2.766-.506,1.759,3.039,2.766,3.039,6.239-3.292,6.262-4.305-3.246-4.558-4-4.812S139.408,47.256,139.408,47.256Z",
    transform: "translate(1.622 -32.847)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.2,45.8s3.694,3.285,4.2,3.285,1.417-4.935,1.417-4.935-2.981-1.956-4.085-1.423S136.2,45.8,136.2,45.8Z",
    transform: "translate(1.635 -33.158)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.191,64.012s0-3.545,7.543-3.545H136l-1.508,8.357-5.029,1.519Z",
    transform: "translate(-0.252 -30.102)",
    fill: "#8985a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.248,39.685a19.393,19.393,0,0,1-2.212-.137,6.206,6.206,0,0,0-2.105-3.02,7.944,7.944,0,0,0-2.114-1.169c-1.675-.717-4.464-.27-4.627.546-3.3,1.587-2.464,4.373-2.464,4.373.512,1.091,1.661.607,2.636.113a1.932,1.932,0,0,0,1.679,1.493c1.611.061,2.391.74,2,1.635s-.855,3.02.9,2.7,2.307.38,2,.92.783-1.075.783-1.075.977,1.466,2.175.44a.916.916,0,0,0,.251-.431,1.791,1.791,0,0,0,1.25.22c1.436-.647.544-2.167.544-2.167s1.918-.3,1.3-.247-1.009-.758.036-2.212S142.217,39.718,141.248,39.685Z",
    transform: "translate(0.166 -34.468)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.162,38.062l-.716-.24-.715,2.163.716.24Z",
    transform: "translate(0.526 -33.984)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,54.556s-.3,1.008,1.4,1.914,2.2,4.333.2,5.34-2.6,2.317-1.6,3.224,2.8,3.325.4,3.93-2.7,1.814-2,2.317-1.6-.907-1.6-.907-.4,2.418-2.5,1.814-8-12.091-5-13.7S59.93,54.556,59.93,54.556Z",
    transform: "translate(-13.418 -31.115)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.322,127.478l.65,6.114-2.818,1.747-2.6-.436,1.3-7.424Z",
    transform: "translate(-13.562 -18.614)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.363,66.634a6.114,6.114,0,1,0-6.07-6.114A6.092,6.092,0,0,0,54.363,66.634Z",
    transform: "translate(-13.435 -31.141)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.169,62.2s.542,9.28,1.192,9.28-7.588-.437-7.588-.437,3.469-6.114,1.734-8.079S56.169,62.2,56.169,62.2Z",
    transform: "translate(-13.181 -29.868)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.553,103.991l2.818,10.918L48.2,133.469l4.986-.437,1.951-29.041Z",
    transform: "translate(-13.562 -22.641)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.553,103.991l2.818,10.918L48.2,133.469l4.986-.437,1.951-29.041Z",
    transform: "translate(-13.562 -22.641)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.082,131.85s.217-1.31,2.385,0,11.273,5.459,6.5,6.333-14.525-1.092-14.525-1.747-.217-4.8.65-4.367S50.782,135.345,52.082,131.85Z",
    transform: "translate(-13.756 -17.965)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9,130.78s-3.469,5.459-3.685,6.988-3.469-3.493-3.469-3.493l3.035-5.678Z",
    transform: "translate(-14.386 -18.423)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.164,104.8l-3.9,13.1s-6.937,18.561-7.371,18.343-5.636-1.529-5.853-2.184,6.5-18.343,6.5-18.343l.867-11.355Z",
    transform: "translate(-14.165 -22.577)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.577,132.7a2.833,2.833,0,0,1,1.687.418,2.865,2.865,0,0,1,1.131,1.328,4.438,4.438,0,0,0,2.168,2.4c.217.218-.65,4.8,0,5.241s1.3,5.022-.867,5.022-5.636-2.4-5.42-2.838a9.816,9.816,0,0,0-.434-4.8c-.65-1.311-1.734-3.494,0-4.8S42.577,132.7,42.577,132.7Z",
    transform: "translate(-14.873 -17.721)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.822,88.08l.434,3.93a19.106,19.106,0,0,1,4.336,7.206c1.084,3.93,9.972,10.482,7.371,11.355s-5.636,1.311-13.224,0-19.511,1.529-19.511-5.677c0,0-1.518-1.966-2.6.873a57.384,57.384,0,0,1-2.6,5.678s-2.6-4.586-1.734-6.551,0-1.748,1.084-3.931,6.5-10.263,8.671-10.7,6.287-6.114,6.07-6.769S63.822,88.08,63.822,88.08Z",
    transform: "translate(-15.523 -26.164)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.482,66.523S59.37,68.488,59.8,69.8a13.263,13.263,0,0,0,2.326,3.144A12.309,12.309,0,0,1,65.19,79.2c.226,1.393-.724,2.646-1.159,4.25-1.3,4.8-2.276,3.6-.976,7.1s-6.5,4.8-9.539,3.275-6.4-10.591-6.4-11.682-2.927-13.429-.542-14.3S50.482,66.523,50.482,66.523Z",
    transform: "translate(-13.889 -29.064)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.021,75.47l2.6,11.573,8.563,3.821s6.5-1.528,6.72.874c.142,1.568-7.371,2.184-7.371,2.184L59.07,89.009l-2.818-10.7Z",
    transform: "translate(-12.07 -27.53)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.144,71.742s5.42,3.275,4.119,5.022-4.553,4.586-5.42,4.586-1.517-5.241-1.517-6.769S58.144,71.742,58.144,71.742Z",
    transform: "translate(-12.229 -28.169)",
    fill: "#575a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.494,52.848s-.332,1.116,1.551,2.121,2.438,4.8.222,5.916-2.881,2.567-1.773,3.572,3.1,3.683.443,4.353-2.992,2.009-2.216,2.567-1.773-1-1.773-1-.443,2.679-2.77,2.009S43.528,59.538,46.122,56.4C48.534,53.487,54.494,52.848,54.494,52.848Z",
    transform: "translate(-14.003 -31.408)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.016,51.979c0-1.635-4.858-.46-6.94,1.823-1.442,1.581-3.632,3.96-1.8,5.637S44.132,63.313,42.8,63.98s-3.974,2.7-1.592,4.072,2.343,2.747,1.447,3.074,1.976-.486,1.976-.486-.29,2.7,2.13,2.687,9.364-13.41,7.7-17.134C52.92,52.73,56.016,51.979,56.016,51.979Z",
    transform: "translate(-14.815 -31.688)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.558,51.564c6.5-.394,7.147,4.531,7.147,4.531-.045,2.85-4.538,1.461-5.786,1.886-1.506-1.091-4.408-3.155-6.483-4.628A9.771,9.771,0,0,1,53.558,51.564Z",
    transform: "translate(-13.41 -31.632)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.267,100.3H94.189v48.818h2.077Z",
    transform: "translate(-5.567 -23.273)",
    fill: "#381e1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.189,100.54s3.531-4.463,6.439,1.325c0,0-1.385,2.581-1.8,1.325s-1.411-3.131-2.575-2.018",
    transform: "translate(-5.567 -23.514)",
    fill: "#381e1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.356,93.021s5.225,5.181,2.652,9.556a1.031,1.031,0,0,1-.319.337,1.024,1.024,0,0,1-1.288-.13c-.887-.883-2.289-3.078-4.012-8.508Z",
    transform: "translate(-6.047 -24.521)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.367,69.729s5.4,1.674,4.362,8.229a50.013,50.013,0,0,0-.623,11.158l1.385,8.369L94,100.9s-4.293-4.324-5.747-8.718S86.936,70.426,91.367,69.729Z",
    transform: "translate(-6.726 -28.514)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.309,69.67s5.4,1.674,4.362,8.229a50.014,50.014,0,0,0-.623,11.158l1.385,8.369-2.493,3.417s-4.293-4.324-5.747-8.718S86.877,70.367,91.309,69.67Z",
    transform: "translate(-6.736 -28.524)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.456,133.411l-.885,6.678s2.273.937,2.954.725,1.875.649,1.875.649,5.078,1.617,6.076.164-1.265-1.9-3.1-2.991-2.611-5.319-2.611-5.319Z",
    transform: "translate(-7.216 -17.613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.417,93.156v24.688l-4.708,23.573H85.723l.762-22.6s-5.193-18.272-2.908-25.107Z",
    transform: "translate(-7.486 -24.498)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.561,95.815s7.259,1.035,7.774,6.094a1.039,1.039,0,0,1-.311.853,1.025,1.025,0,0,1-.4.238,1.009,1.009,0,0,1-.461.039c-1.235-.179-3.658-1.1-8.249-4.436Z",
    transform: "translate(-6.471 -24.042)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.176,69.166a9.119,9.119,0,0,0-.692,5.509s-6.958-.593-6.751-4.638c0,0,3.393-.837,4.189-3.94Z",
    transform: "translate(-7.189 -29.137)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.319,134.661l-.885,6.678s2.273.937,2.954.725,1.875.65,1.875.65,5.078,1.615,6.076.163-1.265-1.9-3.1-2.991-2.611-5.319-2.611-5.319Z",
    transform: "translate(-7.925 -17.399)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.954,94.793v24.688l-4.708,23.573H81.26l.762-22.6s-5.193-18.272-2.908-25.107Z",
    transform: "translate(-8.251 -24.217)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.776,94.793v24.688l-4.708,23.573H81.083l.762-22.6s-5.193-18.272-2.908-25.107Z",
    transform: "translate(-8.281 -24.217)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.182,69.856S83.82,67,80.912,75.505s-1.731,24.2-1.731,24.2,12.394,4.045,16.825-1.6V89.663s2.354-9.624-.969-17.993C95.036,71.669,92.128,72.855,88.182,69.856Z",
    transform: "translate(-8.18 -28.572)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.065,70.035s-4.362-2.859-7.27,5.649-1.731,24.2-1.731,24.2,12.394,4.045,16.825-1.6V89.841s2.354-9.624-.969-17.993C94.919,71.848,92.011,73.034,88.065,70.035Z",
    transform: "translate(-8.2 -28.541)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.065,69.856S83.7,67,80.795,75.505s-1.731,24.2-1.731,24.2,12.394,4.045,16.825-1.6V89.663s2.354-9.624-.969-17.993C94.919,71.669,92.011,72.855,88.065,69.856Z",
    transform: "translate(-8.2 -28.572)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.506,73.42s5.4,1.674,4.362,8.229a50.02,50.02,0,0,0-.623,11.159l6.924,7.044-2.493,3.417s-9.832-3-11.286-7.393S79.075,74.118,83.506,73.42Z",
    transform: "translate(-8.074 -27.881)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.211,73.6s5.4,1.674,4.362,8.229a50.019,50.019,0,0,0-.623,11.159l6.924,7.044-2.493,3.417s-9.832-3-11.286-7.393S78.78,74.3,83.211,73.6Z",
    transform: "translate(-8.125 -27.851)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,73.42s5.4,1.674,4.362,8.229a50.014,50.014,0,0,0-.623,11.159l6.924,7.044L91.5,103.269s-9.832-3-11.286-7.393S78.9,74.118,83.33,73.42Z",
    transform: "translate(-8.104 -27.881)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.454,66.306l3.254,3.069a3.26,3.26,0,0,0-.145.3,4.885,4.885,0,0,1-4.7-1.134A5.168,5.168,0,0,0,88.454,66.306Z",
    transform: "translate(-6.823 -29.101)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.749,68.555a5.649,5.649,0,1,0-5.608-5.649A5.629,5.629,0,0,0,89.749,68.555Z",
    transform: "translate(-7.29 -30.652)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.548,70.787a5.649,5.649,0,1,0-5.608-5.649A5.629,5.629,0,0,0,90.548,70.787Z",
    transform: "translate(-7.153 -30.27)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.041,62.079s-2.1,5.539,2.343,7.233a2.646,2.646,0,0,0,1.4-1.95,2.66,2.66,0,0,0-.746-2.287Z",
    transform: "translate(-7.22 -29.826)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.151,61.441s1.936.473-1.457,1.659a4.3,4.3,0,0,0-2.542,2.31,2.644,2.644,0,0,1-1.566,1.4,2.62,2.62,0,0,1-2.088-.19l-1.074-.595-1.869-4.394,2.216-2.58,3.808-.488Z",
    transform: "translate(-7.219 -30.428)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.538,67.008c.306,0,.554-.437.554-.976s-.248-.976-.554-.976-.554.437-.554.976S88.232,67.008,88.538,67.008Z",
    transform: "translate(-6.631 -29.315)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.83,69.789s3.773,5.963,5.92,5.963-1.505-5.591-1.505-5.591l-.087,1.546Z",
    transform: "translate(-6.829 -28.504)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.59,134.4s2.689.9,4.183,0Z",
    transform: "translate(-17.841 -17.428)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.836,134.4s2.688.9,4.183,0Z",
    transform: "translate(7.915 -17.428)",
    opacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPension);
export default __webpack_public_path__ + "static/media/hero_pension.8d01a581436c418f6bb04d8790d9451e.svg";
export { ForwardRef as ReactComponent };